












  import { Vue, Component, Prop } from 'vue-property-decorator'
  import { Products, Suggestions } from '@one/types'

  @Component({
    components: {
      OneProductTileGallerySwiperCarousel: () =>
        import('~/components/molecules/carousels/OneProductTileGallerySwiperCarousel.vue'),
      OneProductTileGalleryHoverCarousel: () =>
        import('~/components/molecules/carousels/OneProductTileGalleryHoverCarousel.vue'),
    },
  })
  export default class OneProductTileGallery extends Vue {
    @Prop({
      type: Boolean,
      required: true,
    })
    extended!: boolean

    @Prop({
      type: Boolean,
      required: false,
      default: true,
    })
    showIcons!: boolean

    @Prop({
      type: Array,
      required: true,
    })
    bigPhotos!: Array<string>

    @Prop({
      type: Array,
      required: true,
    })
    photos!: Array<Products.ExternalUrl>

    @Prop({
      type: Array,
      required: true,
    })
    mediumPhotos!: Array<string>

    @Prop({
      type: Array,
      required: true,
    })
    smallPhotos!: Array<string>

    @Prop({
      type: Array,
      required: true,
    })
    characteristics!: Array<Suggestions.CharacteristicValue>

    @Prop({
      type: String,
      default: 'https://static-demo-images.s3-eu-west-1.amazonaws.com/photo_plcs_min.svg',
    })
    placeholderImageSrc!: string

    @Prop({
      type: Boolean,
      default: false,
    })
    forceMinHeight!: boolean

    @Prop({
      type: Boolean,
      default: false,
    })
    forceMaxHeight!: boolean

    get productPageAndSmallScreen() {
      return this.extended && ['xs', 'sm', 'md'].includes(this.$mq)
    }

    get productPageAndSmallScreenWithMultipleImages() {
      return this.productPageAndSmallScreen && this.images.length > 1
    }

    get images() {
      return this.mediumPhotos.map(url => ({ url }))
    }
  }
